const Information = () => import('./Information.vue')

export {
  Information
}



// WEBPACK FOOTER //
// ./src/pages/information/index.js